(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-tipsinfo-support.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-tipsinfo-support.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectTipsinfoSupport = svs.components.tipsen.engine.selectors.engineSelectors.selectTipsinfoSupport;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const useTipsinfoSupport = () => {
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const tipsinfoSupport = useSelector(state => selectTipsinfoSupport(state, pageType));
  const allSupportedTipsinfo = useMemo(() => Object.keys(tipsinfoSupport).filter(key => tipsinfoSupport[key]).sort(), [tipsinfoSupport]);
  const allNonSupportedTipsinfo = useMemo(() => Object.keys(tipsinfoSupport).filter(key => !tipsinfoSupport[key]).sort(), [tipsinfoSupport]);
  return {
    tipsinfoSupport,
    allSupportedTipsinfo,
    allNonSupportedTipsinfo
  };
};
setGlobal('svs.components.tipsen.hooks.useTipsinfoSupport', useTipsinfoSupport);

 })(window);